import React from "react";
import { Drawer } from "antd";
import { useSelector, useDispatch } from "react-redux";
import { closeFullDrawer } from "../../store/slices/fullDrawerSlice";
import { ArrowLeftOutlined } from "@ant-design/icons";

const FullDrawer = () => {
    const dispatch = useDispatch();
    const { visible, content } = useSelector((state) => state.fullDrawer);

    return (
        <Drawer
            open={visible}
            onClose={() => dispatch(closeFullDrawer())}
            placement="right"
            width="100%"
            closable={false}
            styles={{
                body: { padding: 0, background: "#070A12" },
                wrapper: { background: "#070A12" },
            }}
            className="custom-fullscreen-drawer [&_.ant-drawer-content]:!bg-[#070A12]"
        >
            <div className="relative overflow-hidden border-b border-white/10 bg-white/[0.04] px-5 py-4 backdrop-blur-xl">
                <div className="pointer-events-none absolute -right-16 -top-20 h-40 w-40 rounded-full bg-emerald-500/10 blur-3xl" />
                <div className="relative flex items-center justify-between">
                    <div className="flex items-center gap-3">
                        <button
                            type="button"
                            onClick={() => dispatch(closeFullDrawer())}
                            className="flex h-10 w-10 items-center justify-center rounded-xl border border-white/10 bg-white/[0.06] text-lg text-white/90 transition hover:border-emerald-400/40 hover:text-emerald-300"
                            aria-label="Назад"
                        >
                            <ArrowLeftOutlined />
                        </button>
                        <h2 className="text-lg font-semibold tracking-tight text-white/95 sm:text-xl">Детали промо</h2>
                    </div>
                </div>
            </div>

            <div className="h-[calc(100vh-73px)] overflow-hidden bg-[#070A12] text-white">
                {content}
            </div>
        </Drawer>
    );
};

export default FullDrawer;
